import { apiDev } from '@/scripts/axios';
import { catchError } from '@/scripts/utils/store-dependent';

/* C */
const confirmEmail = payload =>
  apiDev
    .post(`account/confirmEmail`, payload)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const createAccount = params =>
  apiDev
    .post(`account/create`, params)
    .then(({ data: { response } }) => response.token)
    .catch(catchError);

const addAvatar = file =>
  apiDev
    .post(`account/avatar`, file)
    .then(({ data: { response } }) => response)
    .catch(catchError);

/* R */
const getProfile = () =>
  apiDev
    .get(`account/profile`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getBalances = () =>
  apiDev
    .get(`account/balances`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getToken = params =>
  apiDev
    .post(`account/login`, params)
    .then(({ data: { response } }) => response.token)
    .catch(catchError);

const signOut = () =>
  apiDev
    .post(`account/logout`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getAuthorizationUrl = params =>
  apiDev
    .post(`oauth/prepareRequest`, params)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const oauthGetToken = params =>
  apiDev
    .post(`oauth/confirmRequest`, params)
    .then(({ data: { response } }) => response)
    .catch(catchError);

/* U */
const setProfile = params =>
  apiDev
    .put(`account/profile`, params)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const changeEmail = params =>
  apiDev
    .post(`account/changeEmail`, params)
    .then(({ data: { response } }) => response);

const changePassword = params =>
  apiDev
    .post(`account/changePassword`, params)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const resetPassword = params =>
  apiDev
    .post(`account/resetPassword`, params)
    .then(({ data: { response } }) => response)
    .catch(catchError);

/* D */
const removeAvatar = () =>
  apiDev
    .delete(`account/avatar`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

export {
  getToken,
  confirmEmail,
  createAccount,
  getProfile,
  setProfile,
  addAvatar,
  removeAvatar,
  signOut,
  changeEmail,
  changePassword,
  resetPassword,
  getBalances,
  getAuthorizationUrl,
  oauthGetToken,
};
